import React from 'react'

import { Form, Col } from '_zari/core'

const PadronesFormGroup = ({ iValues }) => {
  return (
    <Form.Group>
      <Form.Label text='PADRONES' htmlFor='readonly-padrones' sm={2} alignRightAt='sm' />
      <Col sm={10}>
        <Form.Select id='readonly-padrones' name='readonly-padrones'>
          {iValues.map((x, k) => (
            <option key={k} value={k}>
              {x}
            </option>
          ))}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(PadronesFormGroup)
